import React, { useEffect, useState } from "react";

const CHOICES = [
    "Metaphor",
    "Simile",
    "Alliteration",
    "Hyperbole",
    "Personification"
];

export default function LiteratureGame() {
    const [questions, setQuestions] = useState([]);
    const [currentIndex, setCurrentIndex] = useState(0);
    const [score, setScore] = useState(0);
    const [timeLeft, setTimeLeft] = useState(60);
    const [gameOver, setGameOver] = useState(false);
    const [feedback, setFeedback] = useState(null); // new state: { message, color }

    useEffect(() => {
        fetch("/questions_and_answers.json")
            .then(res => res.json())
            .then(data => {
                const entries = Object.entries(data).map(([sentence, answer]) => ({ sentence, answer }));
                shuffle(entries);
                setQuestions(entries);
            })
            .catch(err => console.error("Failed to load questions:", err));
    }, []);

    // Timer logic
    useEffect(() => {
        if (timeLeft <= 0) {
            setGameOver(true);
            return;
        }
        const t = setTimeout(() => setTimeLeft(timeLeft - 1), 1000);
        return () => clearTimeout(t);
    }, [timeLeft]);

    function shuffle(arr) {
        for (let i = arr.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [arr[i], arr[j]] = [arr[j], arr[i]];
        }
    }

    function handleChoice(choice) {
        if (gameOver) return;

        const correct = questions[currentIndex].answer;

        if (choice === correct) {
            setScore(score + 1);
            setFeedback({ message: "Nice one!", color: "green" });
        } else {
            setFeedback({ message: "Oops, missed that one", color: "red" });
        }

        // Clear feedback after 2 seconds
        setTimeout(() => setFeedback(null), 2000);

        if (currentIndex + 1 < questions.length) {
            setCurrentIndex(currentIndex + 1);
        } else {
            setGameOver(true);
        }
    }

    if (questions.length === 0) {
        return <div>Loading questions…</div>;
    }

    if (gameOver) {
        return (
            <div style={{ textAlign: "center" }}>
                <h1>Great job!</h1>
                <h2>Your Score: {score}</h2>
            </div>
        );
    }

    const question = questions[currentIndex].sentence;

    return (
        <div style={{ textAlign: "center", maxWidth: "600px", margin: "0 auto" }}>
            <h1>Identify the Literary Device!</h1>
            <h2>Time Left: {timeLeft}s</h2>

            <p style={{ fontSize: "24px", margin: "20px 0" }}>
                <strong>{question}</strong>
            </p>

            <div style={{ display: "flex", flexDirection: "column", gap: "10px" }}>
                {CHOICES.map((choice, i) => (
                    <button
                        key={i}
                        onClick={() => handleChoice(choice)}
                        style={{
                            padding: "12px",
                            fontSize: "18px",
                            background: "#ff9ad7",
                            border: "none",
                            borderRadius: "8px",
                            cursor: "pointer"
                        }}
                    >
                        {choice}
                    </button>
                ))}
            </div>

            {feedback && (
                <p style={{ color: feedback.color, marginTop: "20px", fontWeight: "bold" }}>
                    {feedback.message}
                </p>
            )}
        </div>
    );
}
